export const ADD_USER_DATA = 'ADD_USER_DATA'
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA'